var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C8.125 0 7 1.125 7 2.5V37.5C7 38.875 8.125 40 9.5 40H34.5C35.875 40 37 38.875 37 37.5V10L27 0H9.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2742 25.4843L13.013 23.3055C13.533 22.6255 14.543 23.4943 13.973 24.1443C13.3742 24.8543 12.7442 25.6243 12.1442 26.413L14.183 28.9518C14.733 29.7018 13.6342 30.4205 13.0942 29.6805L11.2542 27.3218L9.44549 29.7318C8.93549 30.4605 7.80549 29.6418 8.37549 28.9618L10.3842 26.413C9.75424 25.623 9.14424 24.8543 8.53549 24.1443C7.90674 23.3943 9.07549 22.6255 9.53549 23.3268L11.2742 25.4843Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 23.6842C15.4141 23.3542 15.6941 23.0742 16.0441 23.0742C16.3641 23.0742 16.6341 23.3555 16.6341 23.6842V28.6917H19.3528C20.3316 28.6917 20.3528 30.0005 19.3528 30.0005H16.0453C15.6953 30.0005 15.4153 29.7517 15.4153 29.3917V23.6842H15.4141Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2489 24.5842C21.4789 22.6442 24.4064 22.2954 25.7864 23.3554C26.4664 23.9042 25.7464 24.7742 25.1464 24.3342C24.4064 23.8654 22.7276 23.6454 22.5176 24.6829C22.2476 26.3229 26.5951 25.3842 26.5251 28.0429C26.4551 30.5817 22.7776 30.6404 21.3976 29.5017C21.0664 29.2317 21.0776 28.7929 21.2576 28.5217C21.5176 28.2629 21.8064 28.1729 22.1476 28.4529C22.9664 29.0117 25.0764 29.4317 25.2251 28.0117C25.0964 26.5342 20.9389 27.4229 21.2489 24.5842Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeXls);
export default __webpack_public_path__ + "static/media/large_xls.377badd8bf8c5c85939ab9a086afed3e.svg";
export { ForwardRef as ReactComponent };